(function (Drupal, $, once) {
  Drupal.behaviors.rateWidget = {
    attach: function (context) {
      "use strict";
      $(once("rate-widget-once", "#block-sitewidealert"))
        .each(function () {
          if (window.matchMedia("(min-width: 1024px)").matches) {
            $(this).addClass("loaded");
          } else {
            $(this).addClass("mini loaded");
            $(document).on("click", "#block-sitewidealert.mini", function () {
              $(this).removeClass("mini");
              $(".bg-dark").addClass("active heigher");
              var checkInterval = setInterval(function () {
                if ($("#block-sitewidealert .sitewide-alert").length == 0) {
                  $(".bg-dark").removeClass("active heigher");
                  clearInterval(checkInterval);
                }
              }, 100);
            });
          }
        });
    },
  };
}(Drupal, jQuery, once));
